export const ACCRUED = "da3a1209-4695-11e9-82f6-0242ac120002";
export const CURRENT = "dd85fe16-4695-11e9-82f6-0242ac120002";
export const mezzRateTypeList = [
  { name: "Accrued", value: ACCRUED },
  { name: "Current", value: CURRENT }
];
